import { connect } from 'react-redux'
import * as action from '../../state/associate-payment/action'
import * as selector from '../../state/associate-payment/selector'
import AssociatePayment from './AssociatePayment'


const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
    }
}

const mapDispatchToProps = {
    findUnassignedPaymentList: action.findUnassignedPaymentList,
    editUnassignedPayment: action.editUnassignedPayment,
    changeTableSetting: action.changeTableSetting,
    initialColumnsVisibility: action.initialColumnsVisibility,
    toggleColumnVisibility: action.toggleColumnVisibility,
    changeCustomer: action.changeCustomer,
    changeSalesOrder: action.changeSalesOrder,
    associatePayment: action.associatePayment,
    deletePayment: action.deletePayment,
}


export default connect(mapStateToProps, mapDispatchToProps)(AssociatePayment)



// WEBPACK FOOTER //
// ./src/modules/payment/component/associate-payment/AssociatePaymentContainer.js